<mat-divider [ngStyle]="{
  'border-top-color': color || '#7B818C',
  'border-top-width': thickness || '1px'
}"></mat-divider>
